import { deprecatedComponent } from '../core/deprecated-component.js';
import { createComponent } from '../core/create-component.js';

/**
 * @subcomponent Button
 * @deprecated To maintain a high-quality user experience, we are no longer supporting this feature, and are not providing a direct replacement.
 */ const ButtonSuperBreak = deprecatedComponent({
    displayName: 'ButtonSuperBreak',
    description: 'ButtonSuperBreak is deprecated; to maintain a high-quality user experience, we are no longer supporting this feature, and are not providing a direct replacement.',
    root: createComponent({
        root: 'br',
        displayName: 'ButtonSuperBreak',
        propConfig: {
            classNames: [
                'swan-button-super-break'
            ]
        }
    })
});

export { ButtonSuperBreak };
